var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#AFCB37",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8936 25L35.8564 45.7121L26.375 36.4308L22 40.7165L36.5811 55L57 29.2857L51.8936 25Z",
    fill: "#AFCB37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLime);
export default __webpack_public_path__ + "static/media/checkLime.7844293c8dc9a3ce66149f6276dc0dca.svg";
export { ForwardRef as ReactComponent };